import { DataConnectionCredentials } from "common";
import { createContext, type JSX, ReactNode, useState } from "react";

interface Props {
  children?: ReactNode;
}

export interface ISshDataConnectionContext {
  connectionCredentials: DataConnectionCredentials | null;
  setConnectionCredentials: (newState: DataConnectionCredentials) => void;
}

const initial = {
  connectionCredentials: null,
  setConnectionCredentials: (): void => {},
};

const SshDataConnectionContext =
  createContext<ISshDataConnectionContext>(initial);

const SshDataConnectionProvider = ({ children }: Props): JSX.Element => {
  const [connectionCredentials, setConnectionCredentials] =
    useState<DataConnectionCredentials | null>(null);

  return (
    <SshDataConnectionContext.Provider
      value={{ connectionCredentials, setConnectionCredentials }}>
      {children}
    </SshDataConnectionContext.Provider>
  );
};

export { SshDataConnectionContext, SshDataConnectionProvider };
